<script setup>
import { translate } from '@/plugins/i18n.js'
import { useCustomerStore } from '@/stores/customer.js'
import { storeToRefs } from 'pinia'
import { computed, onMounted, ref } from 'vue'

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [
      {
        PAGE_URL: { ADMIN: adminUrl }
      }
    ] = await Promise.all([import('@/constants/GlobalConstants')])

    cache = { adminUrl }
    return cache
  }
})()

const customerStore = useCustomerStore()
const { salutation, customerProfile } = storeToRefs(customerStore)

const salutationText = computed(() => {
  const salutationValue = salutation.value ?? translate('wine_lover')
  return translate(
    'header_usp_bar_customer_info_customer_salutation',
    salutationValue
  )
})

const creditsMessage = computed(() => {
  let key
  let data = [customerProfile.value?.credits_formatted]
  if (customerProfile.value?.credits_expire_days_left === null) {
    key = 'header_usp_bar_customer_info_customer_credits'
  } else if (customerProfile.value?.credits_expire_days_left > 1) {
    key = 'header_usp_bar_customer_info_credits_expire_in_more_days'
    data = [...data, customerProfile.value?.credits_expire_days_left]
  } else if (customerProfile.value?.credits_expire_days_left === 1) {
    key = 'header_usp_bar_customer_info_credits_expire_in_one_day'
    data = [...data, 1]
  } else {
    key = 'header_usp_bar_customer_info_credits_expire_today'
  }
  return translate(key, ...data)
})

const adminUrl = ref(null)

onMounted(async () => {
  const { adminUrl: fetchedAdminUrl } = await _getModules()
  adminUrl.value = fetchedAdminUrl
})
</script>

<template>
  <VContainer class="font-size-s pa-0 d-flex" fluid>
    <div class="bg-primary py-1 px-3 text-center w-100">
      <span class="font-weight-bold">
        {{ salutationText }}
      </span>
      <span v-if="customerProfile?.credits_formatted">
        , {{ creditsMessage }}
      </span>
      <span
        v-else-if="customerProfile?.meta_navigation"
        v-html="`, ${customerProfile?.meta_navigation}`"
      ></span>
      <a
        :href="adminUrl"
        v-if="adminUrl && customerProfile?.is_admin"
        class="font-weight-bold mx-3"
        >Admin</a
      >
    </div>
  </VContainer>
</template>
